import { Box, Icon } from "@chakra-ui/react";
import React from "react";

interface SidebarIconProps {
  icon: React.ReactNode | any;
  size?: number;
}

export const SidebarIcon = ({ icon, size = 24 }: SidebarIconProps) => {
  const containerSize = "36px";

  // Caso seja JSX (ex: <svg />, <img />)
  if (React.isValidElement(icon)) {
    return (
      <Box
        h={"60px"}
        w={size}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Box boxSize={`${size}px`} display="flex" alignItems="center" justifyContent="center">
          {icon}
        </Box>
      </Box>
    );
  }

  // Caso seja um IconType (ex: MdHome, CiSearch, etc)
  return (
    <Box
      h={containerSize}
      w={containerSize}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon as={icon} boxSize={`${size}px`} color="white" />
    </Box>
  );
};
